import { styled } from 'styled-components';

const Container = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ width }) => width}px;
  display: grid;
  grid-template-columns: ${({ width }) => `${width / 2}px ${width / 2}px`};
  grid-template-rows: ${({ width }) => `${width / 2}px ${width / 2}px`};
  border: 1px solid ${({ color }) => color};
  border-radius: 100%;
  box-sizing: border-box;
`;

const PieSegment = styled.div`
  box-sizing: border-box;
  left: -1px;
  top: -1px;
  position: relative;

  &:nth-child(1) {
    border-radius: 100% 0 0 0;
    background: ${({ fill, color }) => fill === 100 && color};
  }
  &:nth-child(2) {
    border-radius: 0 100% 0 0;
    background: ${({ fill, color }) => fill >= 25 && color};
  }
  &:nth-child(3) {
    border-radius: 0 0 0 100%;
    background: ${({ fill, color }) => fill >= 75 && color};
  }
  &:nth-child(4) {
    border-radius: 0 0 100% 0;
    background: ${({ fill, color }) => fill >= 50 && color};
  }
`;

export const PieChart = ({
  className,
  width = 20,
  color = '#FF5767',
  fill = 100,
}) => (
  <Container className={className} width={width} color={color}>
    <PieSegment color={color} fill={fill} />
    <PieSegment color={color} fill={fill} />
    <PieSegment color={color} fill={fill} />
    <PieSegment color={color} fill={fill} />
  </Container>
);

export default PieChart;
